import {useCallback} from 'react'
import {gql, useMutation} from '@apollo/client'
import userQueryResult from '../../../Model/Users/QueryResults/userQueryResult'

export default (onSuccess, onError = () => {}) => {
  const [mutation, {data, error, loading}] = useMutation(
    gql`
        mutation(
              $educatorAcademicInfo: EducatorAcademicInfoInput!
              $userId: ID!

              ){
                updateEducatorAcademicInfo (
                  educatorAcademicInfo: $educatorAcademicInfo
                    userId: $userId
                  ){
                    ${userQueryResult} 
                  }
              }
      `,
  )
  const submit = useCallback(
    (obj) => {
      mutation({variables: obj})
        .then((result) => {
          onSuccess(result)
        })
        .catch((e) => {
          onError(e)
        })
    },
    [mutation, onSuccess, onError],
  )
  return {loading, data: data ? data.updateEducatorAcademicInfo : null, error, submit}
}
